import { useCallback, useEffect } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export function useTrackBannerActionClick(): () => void {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionDetailsPageData();
	const track = useTracking();

	return useCallback(() => {
		void track('starter_dash_prompt_banner_click', {
			context: 'petition',
			destination_petition_id: petitionId,
		});
	}, [track, petitionId]);
}

export function useTrackBannerView(): void {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionDetailsPageData();
	const track = useTracking();

	useEffect(() => {
		void track('starter_dash_prompt_banner_view', {
			context: 'petition',
			destination_petition_id: petitionId,
		});
	}, [track, petitionId]);
}
